import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import { useTheme } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";

import { scrollToSection } from "../lib/utils";

export default function Header() {
  const theme = useTheme();

  const handleAboutClick = (e: React.MouseEvent) => {
    e.preventDefault();
    scrollToSection("about-section");
  };

  const handleServicesClick = (e: React.MouseEvent) => {
    e.preventDefault();
    scrollToSection("services-section");
  };

  return (
    <AppBar position="static" color="transparent" elevation={0}>
      <Toolbar
        sx={{
          height: "var(--header-height, 60px)",
          minHeight: "var(--header-height, 60px)",
          color: theme.palette.common.black,
          px: "var(--section-margin-x, 40px) !important",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            color: theme.palette.common.black,
          }}
        >
          <Typography
            variant="h4"
            component="div"
            sx={{ fontWeight: 700, color: theme.palette.common.black }}
          >
            GRMO
          </Typography>
          <Box sx={{ flexGrow: 1 }} />
          <Box
            sx={{
              display: "flex",
              gap: 4,
              color: theme.palette.common.black,
            }}
          >
            <Box sx={{ display: "inline-block" }}>
              <Link
                href="#about-section"
                onClick={handleAboutClick}
                underline="none"
                color="inherit"
                sx={{
                  typography: "h6",
                  fontWeight: theme.typography.h6.fontWeight,
                  transition: "font-weight 0.15s ease",
                  "&:hover": {
                    fontWeight: 700,
                  },
                  "&::after": {
                    content: "attr(data-text)",
                    display: "block",
                    fontWeight: 700,
                    height: 0,
                    overflow: "hidden",
                    visibility: "hidden",
                  },
                }}
                data-text="À propos"
              >
                À propos
              </Link>
            </Box>
            <Box sx={{ display: "inline-block" }}>
              <Link
                href="#services-section"
                onClick={handleServicesClick}
                underline="none"
                color="inherit"
                sx={{
                  typography: "h6",
                  fontWeight: theme.typography.h6.fontWeight,
                  transition: "font-weight 0.15s ease",
                  "&:hover": {
                    fontWeight: 700,
                  },
                  "&::after": {
                    content: "attr(data-text)",
                    display: "block",
                    fontWeight: 700,
                    height: 0,
                    overflow: "hidden",
                    visibility: "hidden",
                  },
                }}
                data-text="Nos services"
              >
                Nos services
              </Link>
            </Box>
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
